import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Paper from "@material-ui/core/es/Paper";
import Grow from "@material-ui/core/es/Grow";
import List from "@material-ui/core/es/List";
import ListItem from "@mui/material/ListItemText";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from "@material-ui/core/es/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/es/ListItemSecondaryAction";
import Button from '@material-ui/core/es/Button';
import { deleteShare } from "../DeleteAccountActions";
import Icon from "@material-ui/core/es/Icon";
import {FaTrash} from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../shared-emails/scrollbarCss.css'

class DeviceInfoList extends Component {
    
    render() {
        const {classes, account, timeout, content, deleteShare} = this.props;
        const {uploadsInfo} = account.pii;
        const data = content || uploadsInfo;

        if (!data) {
            return null
        }

        if(account && account.deleteShareStatus && account.deleteShareStatus.result == "ok"){
            toast("The link was successfully removed", {type: "success"});
        }

        if(account && account.deleteShareStatus && account.deleteShareStatus.result == "error"){
            toast("Error - Please try again...", {type: "error"});
        }
        
        return (
            // <Grow in timeout={timeout || 1000}>
                <Paper style={{padding: '20px', marginBottom: '40px'}}>

                    <h2 className={classes.title}>Shared Emails</h2>
                    <div className={classes.tableWrapper}>
                        <div style={{minWidth: 'fit-content'}}>
                            <List id='sharedList' className={classes.contactsList} subheader={<li/>}>
                                {data.map(({url}, index) => (                            
                                    <ListItem key={url} style={{paddingLeft: '0', paddingRight: '0'}}>
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                            <div>
                                                <a className={classes.link} href={url} target='_blank'>{url}</a>
                                            </div>
                                            <div>
                                                <ListItemButton style={{top: '70%'}}>
                                                    {/* <Button onClick={() => deleteShare(url)}> */}
                                                        <ListItemText style={{maxWidth: '58px', padding: '0'}} onClick={() => deleteShare(url)}>
                                                            <FaTrash />
                                                        </ListItemText>
                                                    {/* </Button> */}
                                                </ListItemButton>
                                            </div>
                                        </div>
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                        

                        <ToastContainer position={'bottom-center'} hideProgressBar={true} autoClose={5000} />
                        
                        {/*<Hidden smDown>*/}
                            {/*<GridList cellHeight={160} className={classes.gridList} cols={5}>*/}
                                {/*{data.map(tile => (*/}
                                    {/*<GridListTile key={tile.url} cols={1}>*/}
                                        {/*<img src={tile.url} alt={tile.url}/>*/}
                                    {/*</GridListTile>*/}
                                {/*))}*/}
                            {/*</GridList>*/}
                        {/*</Hidden>*/}

                        {/*<Hidden mdUp>*/}
                            {/*<GridList cellHeight={160} className={classes.gridList} cols={3}>*/}
                                {/*{data.map(tile => (*/}
                                    {/*<GridListTile key={tile.url} cols={1}>*/}
                                        {/*<img src={tile.url} alt={tile.url}/>*/}
                                    {/*</GridListTile>*/}
                                {/*))}*/}
                            {/*</GridList>*/}
                        {/*</Hidden>*/}
                    </div>
                </Paper>
            // </Grow>
        );
    }
}

function mapStateToProps({account}) {
    return ({account})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        deleteShare
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceInfoList);



// WEBPACK FOOTER //
// ./src/containers/delete-account/components/UploadsInfoTable.js